<script setup lang="ts">
import ButtonIcon from '@components/buttons/button-icon.vue';
import { computed, provide, reactive, watch } from 'vue';
import { clone } from 'lodash';

const { enableToggleAll, enableToggle } = defineProps<{
    enableToggle?: boolean
    enableToggleAll?: boolean
}>();

if (enableToggleAll && enableToggle) {
    throw new Error('enableToggleAll und toggle gleichzeitig anzuschalten macht keinen Sinn');
}

type expandablesType = { [vueId: string]: boolean };
const expandables = reactive<expandablesType>({});

provide('expandables', expandables);
if (enableToggle) {
    let previousExpandables: expandablesType = clone(expandables);

    watch(() => expandables, () => {
        for (const uid in expandables) {
            if (!expandables[uid] || !previousExpandables[uid]) {
                continue;
            }

            expandables[uid] = false;
            return;
        }

        previousExpandables = clone(expandables);
    }, { deep: true });
}

const isShowAll = computed<boolean>(() => {
    for (const vueId in expandables) {
        if (!expandables[vueId]) {
            return true;
        }
    }
    return false;
});

function toggleAll(toggle: boolean) {
    for (const vueId in expandables) {
        if (expandables[vueId] === toggle) {
            continue;
        }
        expandables[vueId] = toggle;
    }
}
</script>

<template>
    <div :class="$style.accordion__wrapper">
        <div v-if="enableToggleAll" :class="$style.button__wrapper">
            <ButtonIcon v-if="isShowAll" icon="eye" @click="toggleAll(true)">Alle einblenden</ButtonIcon>
            <ButtonIcon v-else icon="eye-slash" @click="toggleAll(false)">Alle ausblenden</ButtonIcon>
        </div>
        <div>
            <slot/>
        </div>
    </div>
</template>

<style lang="scss" module>
    .accordion__wrapper {
        width: 100%;
    }
    .button__wrapper {
        margin-bottom: 1em;
    }
</style>
